var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9BF4388B-0EEE-4535-943C-944784963F05") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8916168,7.76619695 C13.8916168,8.04483792 14.1145706,8.27090512 14.3896637,8.27090512 L14.8756485,8.27090512 C14.6493225,10.1355652 13.1865692,11.618014 11.3463898,11.8472356 L11.3463898,11.3547509 C11.3463898,11.0759785 11.123436,10.8500427 10.8483429,10.8500427 C10.5733795,10.8500427 10.350296,11.0759785 10.350296,11.3547509 L10.350296,11.8472356 C8.51024629,11.6178826 7.04736328,10.1355652 6.82116699,8.27090512 L7.3071518,8.27090512 C7.58224487,8.27090512 7.80519868,8.04483792 7.80519868,7.76619695 C7.80519868,7.48742456 7.58224487,7.26148878 7.3071518,7.26148878 L6.82116699,7.26148878 C7.04749297,5.39669724 8.51024629,3.91437988 10.350296,3.6850268 L10.350296,4.17751157 C10.350296,4.45628397 10.5733795,4.68221974 10.8483429,4.68221974 C11.123436,4.68221974 11.3463898,4.45628397 11.3463898,4.17751157 L11.3463898,3.6850268 C13.1865692,3.91437988 14.6494522,5.39669724 14.8756485,7.26148878 L14.3896637,7.26148878 C14.1145706,7.26148878 13.8916168,7.48742456 13.8916168,7.76619695 Z M12.2711487,9.20790108 C12.4656982,9.01074945 12.4656982,8.69123241 12.2711487,8.49408075 L11.3465195,7.55708478 L11.3465195,6.43371483 C11.3465195,6.1549424 11.123436,5.92900666 10.8484726,5.92900666 C10.5733795,5.92900666 10.3504257,6.1549424 10.3504257,6.43371483 L10.3504257,7.76619695 C10.3504257,7.89999717 10.4028244,8.02840862 10.4962082,8.12304141 L11.5667496,9.20790108 C11.6640244,9.30647691 11.7915191,9.35576483 11.919014,9.35576483 C12.0463791,9.35576483 12.1738739,9.30647691 12.2711487,9.20790108 Z M11.3465195,1.55276624 C14.5063934,1.81064056 17,4.49873729 17,7.76619695 C17,11.2034699 14.2403793,14 10.8483429,14 C7.45643614,14 4.69681548,11.2034699 4.69681548,7.76606552 C4.69681548,4.49873729 7.19042207,1.81064056 10.350296,1.55276624 L10.350296,1.00941634 L10.2430344,1.00941634 C9.96807099,1.00941634 9.7449875,0.783480563 9.7449875,0.504708169 C9.7449875,0.225935775 9.96807099,0 10.2430344,0 L11.4537811,0 C11.7288742,0 11.951828,0.225935775 11.951828,0.504708169 C11.951828,0.783480563 11.7288742,1.00941634 11.4537811,1.00941634 L11.3465195,1.00941634 L11.3465195,1.55276624 Z M10.8484726,12.8875391 C13.6350708,12.8875391 15.9023514,10.5900654 15.9023514,7.76619695 C15.9023514,4.94219701 13.6352005,2.64459194 10.8484726,2.64459194 C8.06174468,2.64459194 5.7945938,4.94206558 5.7945938,7.76606552 C5.7945938,10.5900654 8.06174468,12.8875391 10.8484726,12.8875391 Z M3.28101348,5.7360609 L1.42565918,5.7360609 C1.1506958,5.7360609 0.927612305,5.5099937 0.927612305,5.23135273 C0.927612305,4.95258033 1.1506958,4.72664456 1.42565918,4.72664456 L3.28101348,4.72664456 C3.55610655,4.72664456 3.77906036,4.95258033 3.77906036,5.23135273 C3.77906036,5.5099937 3.55610655,5.7360609 3.28101348,5.7360609 Z M3.28101348,7.82507957 L0.498046875,7.82507957 C0.222953805,7.82507957 -4.26325641e-14,7.59914379 -4.26325641e-14,7.3203714 C-4.26325641e-14,7.04159901 0.222953805,6.81566323 0.498046875,6.81566323 L3.28101348,6.81566323 C3.55610655,6.81566323 3.77906036,7.04159901 3.77906036,7.3203714 C3.77906036,7.59914379 3.55610655,7.82507957 3.28101348,7.82507957 Z M3.28101348,9.91409824 L1.42565918,9.91409824 C1.1506958,9.91409824 0.927612305,9.68816247 0.927612305,9.40939007 C0.927612305,9.13061764 1.1506958,8.9046819 1.42565918,8.9046819 L3.28101348,8.9046819 C3.55610655,8.9046819 3.77906036,9.13061764 3.77906036,9.40939007 C3.77906036,9.68816247 3.55610655,9.91409824 3.28101348,9.91409824 Z",
    id: "path-time"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5393FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004AC9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High-Fi-Dashboard-T2P",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking---T2P",
    transform: "translate(-430.000000, -303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking-[Div]",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graph-[Col-8]",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graph",
    transform: "translate(27.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time4-icon",
    transform: "translate(347.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-time",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-time"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-time"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Gradient/Primary",
    mask: "url(#mask-time)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 17,
    height: 14
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.4032e44291b9d287b3af42498ca4a8ab.svg";
export { ForwardRef as ReactComponent };